// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
export default function(state = {}, action) {
  const typeMap = {
    CATEGORY_PAGE_LOADING() {
      return {
        isLoading: true,
        categoryPage: action.categoryPage
      };
    },
    CATEGORY_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.homepage
      };
    },
    CATEGORY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
